import { FC, useContext, useEffect } from "react";
import { useAppSelector } from "../../../hooks/store.hooks";
import UserDetailsProvider from "../memory/memr";
import InitMiddlewareUserDetails from "../middlewares/InitMiddleware";

export interface TableProps {
  tblData: any;
  tblColumns: any;
}

const OrderDetailsInstance: FC<{}> = () => {
  const { userToken } = useAppSelector((state: any) => state.rootReducer.auth);

  useEffect(() => {}, [userToken]);

  return (
    <UserDetailsProvider>
      <InitMiddlewareUserDetails token={userToken} />
    </UserDetailsProvider>
  );
};

export default OrderDetailsInstance;
